import { useMutation } from "@tanstack/react-query";
import { resolveScopedVaultApi } from "../../../api/vault.api";
import { vaultKeys } from "../queryKeys";

export function useVerifyProofOfAddress() {
  const scopedVaultApi = resolveScopedVaultApi(
    typeof window !== "undefined" ? window.location.pathname : "",
  );

  return useMutation({
    mutationKey: vaultKeys.poaVerification(),
    mutationFn: (formData: FormData) =>
      scopedVaultApi.verifyProofOfAddress(formData),
    gcTime: 30 * 60 * 1000,
  });
}
